import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { LOGIN, OTP } from '@symphony-solo/shared/utils/src';
import { CompanyGroupFacade } from '@symphony-solo/domain/company-group/src';

@Injectable()
export class CompanyServiceEndedGuard implements CanActivate {
  private hasServiceEnded: boolean | null = null;
  constructor(private companyGroupFacade: CompanyGroupFacade, private navController: NavController, private platform: Platform) {}

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.hasServiceEnded) {
      let company: any;
      if (!this.platform.is('capacitor') || !this.platform.is('cordova')) {
        company = await this.companyGroupFacade.getsubdmainCompany(false);
        if (company && company['enabled'] === true) {
          this.navController.navigateForward(LOGIN);
          return false;
        } else if (company && company['enabled'] === false) {
          this.hasServiceEnded = true;
          return false;
        } else {
          return !!company;
        }
      } else if (!company) {
        this.navController.navigateForward(OTP);
        return false;
      }
    } else {
      return true;
    }
  }
}
